import React from 'react'
import { withPrefix } from 'gatsby'
import { Map } from '.'
import RichText from '../../../general/rich-text/RichText'
import { MapVideoOverlay } from './subcomponents/map-video-overlay'
import { useInView } from 'react-intersection-observer';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';

const MapSection = observer(({data, locationData}) => {
    const {uiStore: {isMobile}} = useStore();
    const { ref, inView } = useInView({triggerOnce: true, threshold: isMobile ? .5 : 1});

    return (
        <div 
            className='map-section'>
            <div className="map-intro">
                <div 
                    ref={ref}
                    className="elevate text"
                >
                    <RichText>{data.homePageMapIntroHeading}</RichText>
                    <RichText>{data.homePageMapIntroBody}</RichText>
                </div>

                <MapIntroBackgroundImages inView={inView}/>
            </div>
            <Map data={locationData}/>
            <MapVideoOverlay/>
            
            <style jsx>{`
                .map-section {
                    padding: 0 60px 60px;
                    background: white;
                }



                .map-intro {
                    position: relative;
                    padding: 35px 0px
                }

                .map-intro .text {
                    max-width: 900px;
                    margin: 0 auto;
                    padding: 50px 30px 50px;
                    text-align: center;
                }

                .map-intro :global(p) {
                    margin: 20px 0;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    .map-section {
                        padding: 0;
                    }

                    .map-intro {
                        margin: 0;
                        padding: 140px 0;
                    }
                }
            `}</style>
        </div>  
    )
})

const MapIntroBackgroundImages = ({inView}) => {
    return (
        <>
            <img className={inView ? 'mibg-hand-1' : "hide mibg-hand-1"} src={withPrefix('/images/home-hand-1-2x.webp')} alt="" />
            <img className={inView ? 'mibg-hand-2' : "hide mibg-hand-2"} src={withPrefix('/images/home-hand-2-2x.webp')} alt="" />

            <style jsx>{`
                img {
                    position: absolute;
                    transition: transform .6s ease .2s;
                }


                .mibg-hand-1 {
                    left: -60px;
                    top: 90px;
                    width: 250px;
                }

                .mibg-hand-1.hide {
                    transform: translateX(-100%);
                }

                .mibg-hand-2 {
                    right: -90px;
                    top: 90px;
                    width: 310px;
                }

                .mibg-hand-2.hide {
                    transform: translateX(100%);
                }


                @media (max-width: 769px), (pointer: coarse) {
                    .mibg-hand-2 {
                        top: 30px;
                        width: 260px;
                        right: -50px;
                    }
                    .mibg-hand-1 {
                        top: initial;
                        bottom: 40px;
                        width: 220px;
                        left:0;

                    }
                }


            `}</style>
        </>
    )
}

export default MapSection